import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom"; // Link is needed now
import background from "../assests/images/Doodle Iamge.png";
import circle from "../assests/images/group-4@1x.png";
import logo from "../assests/images/Texpidea Logo 1.png";
import { FaRegUser } from "react-icons/fa";
import { MdLockOutline } from "react-icons/md";
import { RiEyeCloseLine, RiEyeLine } from "react-icons/ri";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Constant from "./Utils/Constant";
import { MdManageAccounts } from "react-icons/md";
import { IoClose as X } from "react-icons/io5"; // Using IoClose as X for the icon

const LoginPage = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [accountType, setAccountType] = useState("");
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);

    // State only for the Refund Policy Modal
    const [showRefundPolicy, setShowRefundPolicy] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        // ... (rest of the handleLogin function remains unchanged)
        if (accountType !== "") {
            if (accountType === "admin") {
                try {
                    const response = await axios.post(`${Constant.BASE_URL}/admin/login`, {
                        email,
                        password,
                    });

                    const { token, name, role } = response.data;
                    localStorage.setItem("token", token);
                    localStorage.setItem("name", name);
                    localStorage.setItem("role", role);
                    window.location.reload();
                    localStorage.setItem("userType", "admin");

                    if (response.status === 200) {
                        toast.success("Login successful!", {
                            position: "top-right",
                            autoClose: 3000,
                        });
                        navigate("/dashboard");
                    } else {
                        setError(response.data.message);
                    }
                } catch (err) {
                    setError("Authentication failed.");
                    toast.error("Please check your credentials.", {
                        position: "top-right",
                        autoClose: 3000,
                    });
                }
            } else if (accountType === "affiliate") {
                try {
                    const response = await axios.post(`${Constant.BASE_URL}/affiliate/login`, {
                        email,
                        password,
                    });
                    const { token, name } = response.data;
                    localStorage.setItem("token", token);
                    localStorage.setItem("name", name);
                    window.location.reload();
                    localStorage.setItem("userType", "Affiliate");

                    if (response.status === 200) {
                        toast.success("Login successful!", {
                            position: "top-right",
                            autoClose: 3000,
                        });
                        navigate("/AffiliateDashboard");
                    } else {
                        setError(response.data.message);
                    }
                } catch (err) {
                    setError("Authentication failed.");
                    toast.error("Please check your credentials.", {
                        position: "top-right",
                        autoClose: 3000,
                    });
                }
            } else if (accountType === "modelmanager") {
                try {
                    const response = await axios.post(`${Constant.BASE_URL}/modelmanager/login`, {
                        email,
                        password,
                    });
                    const { token, name } = response.data;
                    localStorage.setItem("token", token);
                    localStorage.setItem("name", name);
                    window.location.reload();
                    localStorage.setItem("userType", "modelmanager");

                    if (response.status === 200) {
                        toast.success("Login successful!", {
                            position: "top-right",
                            autoClose: 3000,
                        });
                        navigate("/modeldashboard/");
                    } else {
                        setError(response.data.message);
                    }
                } catch (err) {
                    setError("Authentication failed.");
                    toast.error("Please check your credentials.", {
                        position: "top-right",
                        autoClose: 3000,
                    });
                }
            }
        } else {
            toast.error("Select Account Type");
        }
    };

    return (
        <>
            <div className="min-h-screen overflow-hidden min-w-screen">
                <div
                    className="h-screen bg-center bg-cover shadow-md "
                    style={{
                        backgroundImage:
                            "radial-gradient(77.96% 148.88% at 50% -45.8%, #f90 0%, #00003F)",
                        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <div className="absolute w-full h-screen overflow-hidden">
                        <img
                            src={background}
                            alt="background"
                            className="object-cover w-full h-full"
                        />
                    </div>
                    {/* main-div */}
                    <div className="flex flex-col items-center justify-center w-screen h-screen gap-2 mt-20 ">
                        <div className="text-[15px]  py-1 text-center  text-white 2xl:text-4xl   xl:text-2xl ">
                            Texpidea Technologies Pvt. Ltd.
                        </div>
                        <div className="w-[340px] flex flex-col min-h-fit justify-center mb-32 lg:mb-40 2xl:mb-18 xl:pb-[60px]  p-6 rounded-lg border border-solid border-white/69 bg-white/19 backdrop-blur-[13.8px] 2xl:w-[800px] 2xl:h-[1300px] xl:w-[410px]">
                            <div className="relative">
                                <div className="flex items-center justify-center ">
                                    <img
                                        src={logo}
                                        alt="Logo"
                                        className="relative z-10 w-[130px] pt-1 pl-1 2xl:w-[350px]   xl:w-[160px] xl:pt-2 2xl:pl-1"
                                    />
                                </div>
                                <div className="absolute left-0 flex justify-center  w-full h-30 top-1 2xl:w-[750px] 2xl:pt-3  ">
                                    <img src={circle} alt="Circle Image" className="w-full " />
                                </div>
                            </div>
                            <div className="2xl:pl-[35px] ">
                                <div className=" w-full flex flex-row p-2 xl:mb-4 lg:mb-4 rounded-lg border border-solid border-white/49 bg-white/65 backdrop-blur-[13.8px]  2xl:w-[675px]  2xl:mt-8 xl:mt-4">
                                    <div className="flex items-center justify-center w-[38px] text-white rounded-tl rounded-bl bg-brown z-1  2xl:w-[70px] 2xl:h-[70px]" style={{ zIndex: 1, backgroundColor: "#967070" }}>
                                        <MdManageAccounts className="text-2xl lg:mx-2 lg:text-2xl xl:text-2xl 2xl:text-5xl 2xl:w-[200px]" />
                                    </div>
                                    <div className="">
                                        <select
                                            id="accountType"
                                            name="accountType"
                                            className="p-1 pl-3 placeholder-black bg-transparent uppercase border-none rounded-lg outline-none subusername xl:w-[300px] lg:w-[230px] 2xl:w-[350px] 2xl:pt-[15px] 2xl:text-2xl 2xl:color-black xl:text-lg"
                                            style={{ backgroundColor: "transparent" }}
                                            value={accountType}
                                            onChange={(e) => setAccountType(e.target.value)}
                                            required
                                        >
                                            <option value="" disabled >
                                                Select account type
                                            </option>
                                            <option value="admin">admin</option>
                                            <option value="affiliate">affiliate</option>
                                            <option value="modelmanager">modelmanager</option>
                                            {/* Add more options as needed */}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="2xl:pl-[35px] ">
                                <div className="xl:mt-10 w-full flex flex-row mt-4 p-2 mb-8 rounded-lg border border-solid border-white/49 bg-white/65 backdrop-blur-[13.8px] 2xl:p-  2xl:w-[675px]  2xl:mt-8 xl:mt-4">
                                    <div
                                        className="flex items-center justify-center w-[38px] text-white rounded-tl rounded-bl bg-brown z-1  2xl:w-[70px] 2xl:h-[70px] "
                                        style={{
                                            zIndex: 1,
                                            backgroundColor: " #967070",
                                        }}
                                    >
                                        <FaRegUser className="text-2xl xl:text-2xl 2xl:text-5xl 2xl:w-[200px]" />
                                    </div>
                                    <div className="">
                                        <input
                                            id="username"
                                            type="email"
                                            name="username"
                                            className="p-1 pl-3 placeholder-black bg-transparent border-none rounded-lg outline-none subusername w-70 2xl:text-4xl 2xl:pt-[15px]  2xl:color-black xl:text-lg"
                                            style={{ backgroundColor: "transparent" }}
                                            value={email}
                                            placeholder="USERNAME"
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="2xl:pl-[35px] 2xl:p-8">
                                <div className="w-100 flex flex-row  p-2 mb-10 rounded-lg border border-solid border-white/49 bg-white/65 backdrop-blur-[13.8px] 2xl:p- 2xl:w-[680px]">
                                    <div
                                        className="flex items-center justify-center w-[80px]  text-white rounded-tl rounded-bl bg-brown z-1 xl:w-[60px]  2xl:w-[75px] 2xl:h-[70px]"
                                        style={{
                                            zIndex: 1,
                                            backgroundColor: " #987070",
                                        }}
                                    >
                                        <MdLockOutline className="text-2xl xl:text-3xl 2xl:text-5xl  2xl:w-[200px]" />
                                    </div>
                                    <div>
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            name="packname"
                                            className="p-1 pl-3 placeholder-black bg-transparent border-none rounded-lg outline-none subusername1 w-55 2xl:text-4xl 2xl:pt-[15px]  2xl:w-[500px] xl:w-[250px]  xl:text-lg "
                                            placeholder="•••••••••••"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div
                                        className="flex items-center justify-center w-20 rounded-tr rounded-br"
                                        style={{
                                            zIndex: 1,
                                            color: "#3D3D3D",
                                        }}
                                        onClick={togglePasswordVisibility}
                                    >
                                        {showPassword ? (
                                            <RiEyeLine className="text-lg xl:text-2xl 2xl:text-4xl" />
                                        ) : (
                                            <RiEyeCloseLine className="text-lg xl:text-2xl 2xl:text-4xl" />
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col items-center justify-center login pt-25 mt-25 ">
                                <button
                                    className="flex-shrink-0 w-full  p-2 text-lg rounded-lg loginbtn bg-custom-gradient 2xl:w-[680px] 2xl:text-black 2xl:p-7  2xl:text-4xl xl:text-xl"
                                    style={{
                                        background:
                                            "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                                    }}
                                    onClick={handleLogin}
                                >
                                    LOGIN
                                </button>
                            </div>
                            <div className="flex justify-end mt-1 italic text-gray-300 2xl:text-4xl 2xl:mt-4 2xl:text-gray-200 xl:text-xl">
                                Forgot password ?
                            </div>
                        </div>
                        
                        {/* Website Link - Added below the login form box and center-aligned */}
                        <div className="flex justify-center relative -top-40" >
                            <a 
                                href="https://www.texpidea.com" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-white hover:text-orange-500 cursor-pointer 2xl:text-2xl xl:text-lg transition-colors duration-300"
                            >
                                www.texpidea.com
                            </a>
                        </div>
                    </div>
                </div>
                
                <div className="absolute bottom-0 left-0 z-10 flex w-full justify-between mt-4 mb-2 px-12 text-white 2xl:text-4xl 2xl:px-[20px] 2xl:mb-[20px] xl:text-lg xl:px-[30px]">
                    <div>
                        <Link to="/policy" className="mr-4 cursor-pointer hover:text-orange-500">Privacy Policy</Link>
                        <Link to="/terms" className="mr-4 cursor-pointer hover:text-orange-500">T&C</Link>
                        <span onClick={() => setShowRefundPolicy(true)} className="mr-4 cursor-pointer hover:text-orange-500">Refund Policy</span>
                    </div>
                    <div>
                        Copyright © <span className="text-orange-500">2024</span> Texpidea
                        Technologies Pvt. Ltd. All rights reserved.
                    </div>
                </div>
                <ToastContainer />
            </div>

            {/* Refund Policy Modal */}
            {showRefundPolicy && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                    <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                        {/* Modal Header */}
                        <div className="flex justify-between items-center p-6 border-b">
                            <h2 className="text-xl font-semibold text-gray-900">
                                Refund Policy - "Texpidea Technologies Pvt. Ltd."
                            </h2>
                            <button
                                onClick={() => setShowRefundPolicy(false)}
                                className="p-1 hover:bg-gray-100 rounded-full transition-colors"
                            >
                                <X size={24} className="text-gray-500" />
                            </button>
                        </div>

                        {/* Modal Content */}
                        <div className="p-6 space-y-4">
                            <p className="text-sm text-gray-600 mb-4">
                                <strong>Effective Date:</strong> 01/09/2025
                            </p>

                            <p className="text-gray-700">
                                At Texpidea Technologies Pvt. Ltd., we strive to ensure customer satisfaction.
                                This Refund Policy explains how refunds are handled for purchases made through Texpidea Technologies Pvt. Ltd..
                            </p>

                            <div className="space-y-4">
                                <div>
                                    <h3 className="font-semibold text-gray-900 mb-2">1. Eligibility for Refunds</h3>
                                    <ul className="space-y-1 text-gray-700 ml-4 list-disc">
                                        <li>Refunds may be considered only if there is a technical issue that prevents the use of the Service.</li>
                                        <li>To be eligible, users must contact our support team within 7 days of the purchase with valid proof.</li>
                                    </ul>
                                </div>

                                <div>
                                    <h3 className="font-semibold text-gray-900 mb-2">2. Non-Refundable Situations</h3>
                                    <p className="text-gray-700 mb-2">Refunds will not be provided in cases where:</p>
                                    <ul className="space-y-1 text-gray-700 ml-4 list-disc">
                                        <li>The issue is due to user error or lack of device compatibility.</li>
                                        <li>The service has been used or partially consumed.</li>
                                        <li>Refund is requested beyond the 7-day window.</li>
                                    </ul>
                                </div>

                                <div>
                                    <h3 className="font-semibold text-gray-900 mb-2">3. Processing of Refunds</h3>
                                    <p className="text-gray-700">
                                        Approved refunds will be processed and credited to the original payment method within 7-10 business days.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Modal Footer */}
                        <div className="flex justify-end p-6 border-t bg-gray-50">
                            <button
                                onClick={() => setShowRefundPolicy(false)}
                                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default LoginPage;